import routerOptions0 from "/codebuild/output/src4287943582/src/gx-booking/node_modules/.pnpm/nuxt@3.15.4_eslint@8.57.1_rollup@4.62.4_sass@1.84.0_typescript@5.5.3_vite@4.5.14_vue-tsc@2.0.26/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}